import React, { Component } from 'react'
import Markdown, { md } from 'features/Markdown'
import { Col, Row } from 'components/Layout'
import s from './MultiTextList.scss'
import sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import pickleWithGlasses from 'static/images/pickles/pickle-with-glasses.png'
import Helmet from 'react-helmet'

export default class MultiText extends Component {
  state = {
    active: 0,
  }
  setActive = idx =>
    this.setState({
      active: idx,
    })
  render() {
    const { data } = this.props
    const dataFiltered = data.filter(item => item.title)
    const activeItem = dataFiltered[this.state.active]

    const jsonLdQuestions = dataFiltered.map(({ title, text }) => ({
      '@type': 'Question',
      name: title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: md.render(text || ''),
      },
    }))

    const jsonLd = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: jsonLdQuestions,
    })

    return (
      <Row className={cn(sLay['layout-gt-xs-row'], sLay['layout-xs-column'], 'lg')}>
        <Col className={cn(sLay['flex-gt-xs-40'], 'lg', s.imageCol)}>
          <img src={pickleWithGlasses} />
        </Col>
        <Col
          className={cn(sLay['flex-gt-xs-60'], 'lg', sLay['hide-xs'])}
          style={{ marginBottom: '60px' }}
        >
          {dataFiltered.map(({ title }, idx) => {
            const isActive = idx === this.state.active
            return (
              <div className={s.item} key={title}>
                <a
                  className={cn(s.title, { [s.active]: isActive })}
                  onClick={() => this.setActive(idx)}
                >
                  {title}
                  <div className={sLay.flex} />
                  <div className={s.icon}>{isActive ? '-' : '+'}</div>
                </a>
                {isActive && <Markdown text={activeItem.text} />}
              </div>
            )
          })}
        </Col>
        <Helmet>
          <script type="application/ld+json">{jsonLd}</script>
        </Helmet>
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/MultiText/MultiTextList/MultiTextList.jsx